var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import DateInput from "../../components/ui/DateInput/DateInput";
import React from "react";
import { Col, Row } from "reactstrap";
import { observer } from "mobx-react";
import { ApplicationContext } from "../../../ApplicationContext";
import { injectIntl } from "react-intl";
import BasicFormGroup from "../../components/ui/BasicFormGroup/BasicFormGroup";
var ReportDateRange = /** @class */ (function (_super) {
    __extends(ReportDateRange, _super);
    /**
     *
     */
    function ReportDateRange(props) {
        var _this = _super.call(this, props) || this;
        var startDate = new Date();
        startDate.setDate(startDate.getDate() - 7); // One week ago
        var endDate = new Date();
        _this.state = {
            startDate: startDate,
            endDate: endDate
        };
        return _this;
    }
    ReportDateRange.prototype.componentDidMount = function () {
        this.updateReportParameter();
    };
    ReportDateRange.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        this.updateReportParameter();
    };
    ReportDateRange.prototype.render = function () {
        var _this = this;
        var intl = this.props.intl;
        var _a = this.state, startDate = _a.startDate, endDate = _a.endDate;
        return React.createElement(Row, null,
            React.createElement(Col, null,
                React.createElement(BasicFormGroup, { htmlFor: "startDate", label: intl.formatMessage({ id: 'reports.settings.form.daterange.startdate' }) },
                    React.createElement("div", { className: "input-group", "data-errorHandler": "endDate" },
                        React.createElement(DateInput, { intl: intl, id: "startDate", name: "startDate", onBlur: function (e, date) { return _this.setState({ startDate: _this.filterDate(date) }); }, onChange: function (e, date) { return _this.setState({ startDate: _this.filterDate(date) }); }, value: startDate ? startDate : null, openToDate: startDate, required: true }),
                        React.createElement("div", { className: "input-group-append" },
                            React.createElement("span", { className: "input-group-text" },
                                React.createElement("i", { className: "fe fe-calendar" })))))),
            React.createElement(Col, null,
                React.createElement(BasicFormGroup, { htmlFor: "startDate", label: intl.formatMessage({ id: 'reports.settings.form.daterange.enddate' }) },
                    React.createElement("div", { className: "input-group", "data-errorHandler": "endDate" },
                        React.createElement(DateInput, { intl: intl, id: "endDate", name: "endDate", onBlur: function (e, date) { return _this.setState({ endDate: _this.filterDate(date) }); }, onChange: function (e, date) { return _this.setState({ endDate: _this.filterDate(date) }); }, value: endDate ? endDate : null, openToDate: endDate, required: true }),
                        React.createElement("div", { className: "input-group-append" },
                            React.createElement("span", { className: "input-group-text" },
                                React.createElement("i", { className: "fe fe-calendar" })))))));
    };
    ReportDateRange.prototype.filterDate = function (date) {
        if (date && !isNaN(date.getTime())) {
            return date;
        }
        return new Date();
    };
    ReportDateRange.prototype.updateReportParameter = function () {
        var reportParameterModel = this.props.reportParameterModel;
        var _a = this.state, startDate = _a.startDate, endDate = _a.endDate;
        reportParameterModel.value = { from: startDate, to: endDate };
    };
    ReportDateRange = __decorate([
        observer
    ], ReportDateRange);
    return ReportDateRange;
}(React.Component));
ReportDateRange.contextType = ApplicationContext;
export default injectIntl(ReportDateRange);
